import React, { useMemo } from "react";
import TotalForm from "./TotalForm";

const toNum = (v) => {
  const n = Number(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

const round2 = (n) => Math.round((toNum(n) + 1e-10) * 100) / 100;

export default function InvoiceTotal({ doc, readOnly = true, descripcion, setDescripcion }) {
  const merged = useMemo(() => {
    const t = (doc?.totales && typeof doc.totales === "object") ? doc.totales : {};

    const totals = {
      sub15: round2(toNum(t.subtotal_15)),
      sub5: round2(toNum(t.subtotal_5)),
      sub0: round2(toNum(t.subtotal_0)),
      descuento: round2(toNum(t.descuento_total ?? t.descuento)),
    };

    const iva15 = round2(toNum(t.iva_15));
    const iva5 = round2(toNum(t.iva_5));
    const ice = round2(toNum(t.ice));
    const total = round2(toNum(t.total ?? doc?.total));

    return { totals, iva15, iva5, ice, total };
  }, [doc]);

  const descValue = (descripcion ?? doc?.descripcion ?? "").toString();

  return (
    <TotalForm
      descripcion={descValue}
      setDescripcion={setDescripcion}
      totals={merged.totals}
      iva15={merged.iva15}
      iva5={merged.iva5}
      ice={merged.ice}
      total={merged.total}
      readOnly={readOnly}
    />
  );
}
